module.exports = __webpack_public_path__ + "img/coin.2d7a3c53.svg";